import React from 'react';
import styled from 'styled-components';

export const Center: React.FC<ICenterProps> = ({ children, height = '100%' }) => <Centered height={height}>{children}</Centered>;

export interface ICenterProps {
    height?: string;
}

const Centered = styled.div<ICenterProps>`
    display: grid;
    height: ${(props) => props.height};
    align-items: center;
    justify-content: center;
`;
